import { EntityActionNames, IEntityAction } from '../../app/spaces/ActionsMenu/EntityActions/IEntityAction';
import { anyLinkedTaskEnabledSchedule,userCanEditSchedule, userCanEnableLinkedTask } from '../../app/spaces/ActionsMenu/EntityActions/IEntityActionHelpers';
import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import { IScheduleInfo } from '../types/IScheduleInfo';
import { scheduleDisableLinkedTask } from './ScheduleMenuActions';

export const ScheduleDisableLinkedTaskAction: IEntityAction<IScheduleInfo, {}> = {
  name: EntityActionNames.DisableLinkedTask,
  translateName: Messages.linkedTasksDisable,
  isVisible: (targetItems: IScheduleInfo[], state: AppState) => {
    return targetItems.length > 0 && userCanEditSchedule(state, targetItems) && userCanEnableLinkedTask(targetItems);
  },
  isClickable: (_availableActions: {}, targetItems: IScheduleInfo[]) => {
    return anyLinkedTaskEnabledSchedule(targetItems);
  },
  createReduxAction: (targetItems: IScheduleInfo[]) => scheduleDisableLinkedTask(targetItems)
};
